<div class="page-wrapper" [ngClass]="{'embed': isEmbedded}">
  <div class="content-wrapper" [ngClass]="{'change': isEventPage || isFieldAgentPage || eventInfo !== undefined}">
    @if (!isFieldAgentPage && !isEventPage && eventInfo === undefined) {
      <div class="left-column">
        <h1>{{brandConfig?.content?.introHeroTitle}}</h1>
        <div class="cs-inner-html-18">
          <p>{{brandConfig?.content?.introHeroDescription}} <a [href]="brandConfig?.content?.introHeroPhoneHref" target="_blank">{{brandConfig?.content?.introHeroPhoneDisplay}}</a>.</p>
        </div>
      </div>
    }
    @if (isEventPage && !eventInfo && isEventInValid) {
      <div class="expired-warning">
        <div class="icon">
          <img src="/assets/icons/road-sign-warning.svg" alt="">
        </div>
        <h2 class="market-title">Whoops! Looks like this event is no longer active. Please contact your manager for help.</h2>
      </div>
    }
    <div class="right-column">
      @if (isEventPage && eventInfo) {
        <div class="event">
          <h2 class="market-title">{{eventInfo?.name}}</h2>
          <div class="button-holder center">
            <app-button
              class="next disable-visible"
              [fullWidth]="true"
              text="Next"
              type="filled"
              [isUppercase]="true"
              [disabled]="!eventInfo"
              [handleClick]="goToFieldAgents"
              />
          </div>
        </div>
      }
      @if (isFieldAgentPage && eventInfo) {
        <div class="event agent">
          <h2 class="market-title">{{eventInfo?.name}}</h2>
          <div class="agent-form" [formGroup]="agentForm">
            <h2>Select your name below to start.</h2>
            <div class="form-frame">
              <label for="agent">Field Agent</label>
              <ng-select
                #agentSelect
                appearance="outline"
                formControlName="agent"
                [clearable]="false"
                bindLabel="name"
                bindValue="id"
                placeholder="Select"
                class="state-select"
                [dropdownPosition]="'top'"
                >
                @for (option of eventInfo?.fieldAgents; track option) {
                  <ng-option [value]="option.id">{{
                    option.name
                  }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="button-holder center">
            <app-button
              class="next"
              [fullWidth]="true"
              text="START FORM"
              [isUppercase]="true"
              [disabled]="!agentForm.valid"
              type="filled"
              [handleClick]="startRegularForm"
              />
          </div>
        </div>
      }
      @if (!isEventPage && !isFieldAgentPage) {
        <div class="name-wrapper">
          @if (eventInfo?.name) {
            <h2 class="market-title event-title">{{eventInfo.name}}</h2>
          }
          @if (eventFieldAgentName) {
            <span class="field-rep">Field Rep: {{eventFieldAgentName}}</span>
          }
          @if (marketTitle && marketTitle.length) {
            <h2 class="market-title">{{marketTitle + ' Area'}}</h2>
          }
          @if (!isEmbedded) {
            <div class="main-heading modify-text">
              <h2>{{brandConfig?.content?.introFormTitle}}</h2>
              <div class="cs-inner-html-18 subtext">
                <p>{{brandConfig?.content?.introFormDescription}}</p>
              </div>
            </div>
          }
          @if (isEmbedded) {
            <div class="main-heading modify-text">
              <h2>{{brandConfig?.content?.introEmbeddedTitle}}</h2>
              <div class="cs-inner-html-18 subtext"
              >{{brandConfig?.content?.introEmbeddedDescription}}</div>
            </div>
          }
          @if (personalInfoForm) {
            <form
              class="form-wrapper"
              [formGroup]="personalInfoForm"
              >
              <div class="name">
                <app-form-group
                  id="firstName"
                  placeholder="First name*"
                  formControlName="firstName"
                  >
                </app-form-group>
                <app-form-group
                  id="lastName"
                  placeholder="Last name*"
                  formControlName="lastName"
                  >
                </app-form-group>
              </div>
              <div>
                <div class="contact-form">
                  <app-form-group
                    placeholder="Phone number*"
                    id="primaryPhone"
                    formControlName="primaryPhone"
                    type="phone"
                  ></app-form-group>
                  <app-form-group
                    [placeholder]="isEmailRequired ? 'Email*' : 'Email'"
                    id="primaryEmail"
                    formControlName="primaryEmail"
                    type="email"
                  ></app-form-group>
                  <div class="zipcode">
                    <app-form-group
                      placeholder="Zipcode*"
                      id="zipcode"
                      formControlName="zipcode"
                      type="zip"
                    ></app-form-group>
                  </div>
                  <app-checkbox
                    formControlName="contactPreference"
                    [label]="agreementText"
                    [labelHTML]="agreementText"
                  ></app-checkbox>
                </div>
              </div>
              <div class="button-holder">
                <app-button
                  [text]="isEmbedded ? brandConfig?.content?.introEmbeddedCta : brandConfig?.content?.introDefaultCta"
                  [isUppercase]="true"
                  [disabled]="!personalInfoForm.valid"
                  type="filled"
                  [rightIconSrc]="isEmbedded ? '/assets/icons/arrow-right-black.svg' : ''"
                  [handleClick]="onClickNext"
                  />
              </div>
            </form>
          }
        </div>
      }
    </div>
  </div>
  @if (!isEventPage && !isFieldAgentPage && offer) {
    <div class="offer-bar">
      <div class="frame">
        <div class="icon">
          <img src="assets/icons/offer-icon.svg" alt="">
        </div>
        <div class="offer-bar-description">
          <strong class="offer-title">{{offer?.title}}</strong>
          <p>{{offer?.description}}</p>
        </div>
      </div>
    </div>
  }
</div>
